import OrganisationEdit from './OrganisationEdit';

export default OrganisationEdit;
